import { observer } from '~/common/mobx.decorator'
import { NotifyDialog } from '~/components/notify'
import { Typography } from '@material-ui/core'
import { appStore, notifyStore } from '~/stores'
import React from 'react'
import { useMutation } from '@apollo/client'
import { CHECK_OUT_MUTATION } from '~/common/apollo'
import { careJobDetailStore } from '~/features/care-jobs/detail/care-job-detail.store'
import { careStore } from '~/companies/care/care.store'
import { careHomeStore } from '~/features/care-home/care-home.store'
import { useRouteMatch } from 'react-router-dom'

export const CheckoutSuccessDialog = observer(() => {
	const { fetchJob, setIsShowCheckout, setIsShowCheckoutSuccess, isShowCheckout } = careJobDetailStore
	const { fetchWorkerCheckout, currentCheckoutItem } = careHomeStore

	const { getActiveFeature } = careStore
	const { code } = getActiveFeature() || {}
	const isHome = code === 'home'
	const isJobDetail = code === 'jobs'
	const { params } = useRouteMatch()

	const [checkOutJob, { loading: loadingCheckout }] = useMutation(CHECK_OUT_MUTATION, {
		async onError(e) {
			await notifyStore.error(e.message)
		},
		async onCompleted(data) {
			if (isHome) {
				await fetchWorkerCheckout()
			}

			if (isJobDetail) {
				await fetchJob(params?.id)
			}
			await setIsShowCheckout(false)
			await setIsShowCheckoutSuccess(true)
		},
	})

	return (
		<NotifyDialog
			okProps={{ loading: loadingCheckout, disabled: loadingCheckout }}
			onClose={() => setIsShowCheckout(false)}
			showButtonClose={true}
			open={isShowCheckout}
			onCancel={() => setIsShowCheckout(false)}
			okText="Confirm"
			children={
				<>
					<Typography
						css={[
							appStore.getTheme.typography.h4,
							{
								fontWeight: 500,
								color: appStore.getTheme.colors.content.dark,
							},
						]}
					>
						After checking out, your work time would be logged on your timecard. You still can update it later in your timecard submission.
					</Typography>
				</>
			}
			onOk={async () => {
				await checkOutJob({
					variables: {
						workerAssignmentId: currentCheckoutItem?.id,
					},
				})
			}}
			title={`Are you sure to check out of this assignment?`}
		/>
	)
})
